import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-autenticacao-sucesso',
  templateUrl: './sucesso-autenticacao-component.html',
  styleUrls: ['./sucesso-autenticacao-component.scss'],
  standalone: true,
  imports: [RouterModule]
})
export class SucessoAutenticacaoComponent {


  // Injeção do serviço Location
  private readonly location = inject(Location);

  constructor() { }

  /**
   * Navega para a página anterior no histórico do navegador.
   */
  voltar(event: Event): void {
    event.preventDefault(); // Impede o navegador de seguir o link '#'
    this.location.back();
  }
}